import { COMPONENT_NAME as MAP_COMPONENT_NAME, MapDirective } from './map.directive'
import { MAP_SERVICE_NAME, MapServiceProvider } from './services/map.service'

export const MAP_MODULE_NAME = 'simax.common.map'

const module = angular.module(MAP_MODULE_NAME, [])

module.directive(MAP_COMPONENT_NAME, [() => new MapDirective()])
module.provider(MAP_SERVICE_NAME, MapServiceProvider)

